import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import About from './About';
import FAQs from 'features/challenges/FAQs';
import Hero from './Hero';

export default function Start({ challenge }) {
  const currentUser = useSelector(selectCurrentUser);
  const inProgress = currentUser?.unlockedHubs.includes(challenge?.id);

  return (
    <>
      <Hero challenge={challenge} inProgress={inProgress} />
      <About challenge={challenge} />
      <FAQs />
    </>
  );
}
